import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import {Helmet} from "react-helmet"
import SeoHeaders from "../components/seoheaders";
import * as wActs from "../actions/website-actions";
import {isNullOrUndefined} from "../actions/website-actions";
import {FormattedMessage} from 'react-intl';
import * as wConsts from "../consts/website-consts";
import HtmlSection from "../components/htmlsection";
import SideBanners from "../components/sidebanners";
import {Link} from "react-router-dom";
import Pager from "../components/pager";
import SsrBanner from "../components/ssrbanner";
import BuyAdBanner from "../components/buyadbanner";


class Links extends Component {


  constructor(props) {
    super(props);
    let url = typeof window !== "undefined" ? "http://www.fakeurl.com" + window.location.search : "http://www.fakeurl.com" + props.WebPage.ServerParams.Query;
    this.state = {
      CurrentView: "NOTSET",
      filter: wActs.getParameterByName("linktype",url,"ournetwork")
    };

    if(this.state.filter!="other" && this.state.filter != "ournetwork") {
      this.state.filter="ournetwork";
    }
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "links" });

  }

  handleClick(e,val) {
    this.setState({CurrentView: val});
  }


  componentDidMount() {
  }

  dynamicSort(property) {
    let sortOrder = 1;
    if(property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a,b) {
      let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    let sizes = [];
    let langs = [];
    if(!wActs.isNullOrUndefined(nextProps.WebPage.Page.Creative) && !wActs.isNullOrEmpty(nextProps.WebPage.Page.Creative.Own) && nextState.CurrentView === "NOTSET") {
      let bans = nextProps.WebPage.Page.Creative.Own;
      bans.map((v) => {
        if(!langs.some((t) => t === v.LanguageCode)) {
          langs.push(v.LanguageCode);
        }
        if(!sizes.some((t) => t === v.Size)) {
          sizes.push(v.Size);
        }
      });
      nextState.CurrentView = sizes[2];
    }
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  getPage() {
    let t = this.getTranslation("page.links.howitworks");
    t = wActs.replaceAll("{{SiteName}}", this.props.WebPage.Settings.SiteName, t);
    t = wActs.replaceAll("{{SubmitLinkUrl}}", "https://" + this.props.WebPage.Settings.Domain +"/links", t);
    t = wActs.replaceAll("{{SupportEmail}}", this.props.WebPage.Settings.SupportEmail, t);
    t = wActs.replaceAll("{{SupportUrl}}", wActs.getCultPath(this.props.WebPage,"/support"), t);
    return t;
  }


  render() {

    let langs = [];
    let sizes = [];
    if(!wActs.isNullOrUndefined(this.props.WebPage.Page.Creative) && !wActs.isNullOrEmpty(this.props.WebPage.Page.Creative.Own)) {
      let bans = this.props.WebPage.Page.Creative.Own;
      bans.map((v,i) => {
        if(!langs.some((t) => t === v.LanguageCode)) {
          langs.push(v.LanguageCode);
        }
        if(!sizes.some((t) => t === v.Size)) {
          sizes.push(v.Size);
        }

      });
    }
    let fnd = this.state.CurrentView;
    let self = this;

    let showOther = false;
    if(!wActs.isNullOrEmpty(this.props.HtmlSections) && !wActs.isNullOrEmpty(this.props.HtmlSections['Friends'])) {
      showOther = true;
    }
    let Sites = this.props.Sites ? this.props.Sites:[];

    return (
      <div className="">
        <SeoHeaders Position={"Top"}/>
        <div className="row">
          <div className="col_80">

            <div className="white-box mb">
              <div style={{marginBottom: "10px", fontSize: "14px"}} className="small-p" dangerouslySetInnerHTML={{__html: this.getPage()}}></div>
            </div>


            <div className="white-box mb">

              <div style={{marginBottom: "10px",marginTop: "15px", fontSize: "14px"}} className="small-p" dangerouslySetInnerHTML={{__html: this.getTranslation("page.links.findyouingoogle").replace("{{SiteName}}",this.props.WebPage.Settings.SiteName)}}></div>

              <p style={{margin: "0", marginTop: "20px"}}>
                <div className="row" style={{fontSize: "1.3rem"}}>
                  {Sites.map((v,i)=> {
                    return (
                      <div className="col_33" style={{marginBottom: "20px"}}>
                        {v.Name} - <a href={v.Url} target={"_blank"}>{this.getTranslation("dash.banners")}</a>
                      </div>
                    );
                  })}
                </div>
              </p>

            </div>



            <div className="white-box mb">
              <h2 style={{textAlign: "center", marginBottom: "4px"}}><FormattedMessage id={"page.links.ourbanners"}>{(...content) => content}</FormattedMessage></h2>
              <div style={{marginBottom: "10px", fontSize: "14px"}}>{this.getTranslation("page.links.areyouinterestedinabannerorlinkexchangewithus").replace("{{SiteName}}",this.props.WebPage.Settings.SiteName)}</div>

              {wActs.isNullOrEmpty(this.props.WebPage.Page.Creative) || wActs.isNullOrEmpty(this.props.WebPage.Page.Creative.Own) &&
              <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
                <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
              </p>
              }

              {!wActs.isNullOrEmpty(this.props.WebPage.Page.Creative) && !wActs.isNullOrEmpty(this.props.WebPage.Page.Creative.Own) &&
              <React.Fragment>

                <div className="filters-wrapper" style={{margin: "10px"}}>
                  {
                    sizes.map((v,i) => {
                      if(v=="196x26") {return null;}
                      if(v=="150x16") {return null;}
                      return (
                        <div key={"sizes-check" + i} className="checkbox-input">
                          {v === fnd &&
                          <input type="checkbox" className="filter-button" id={"sizes-" + i} value={v} onChange={(e)=>{return self.handleClick(e,v)}} checked={true}/>
                          }
                          {v !== fnd &&
                          <input type="checkbox" className="filter-button" id={"sizes-" + i} value={v} onChange={(e)=>{return self.handleClick(e,v)}}/>
                          }
                          <label htmlFor={"sizes-" + i}>{this.capitalizeFirstLetter(v)}</label>
                        </div>
                      )
                    })
                  }
                  {
                    langs.map((v,i) => {
                      return (
                        <div key={"langs-check" + i} className="checkbox-input">
                          {v === fnd &&
                          <input type="checkbox" className="filter-button" id={"langs-" + i} value={v} onChange={(e)=>this.handleClick(e,v)} checked={true}/>
                          }
                          {v !== fnd &&
                          <input type="checkbox" className="filter-button" id={"langs-" + i} value={v} onChange={(e)=>this.handleClick(e,v)}/>
                          }
                          <label htmlFor={"langs-" + i}>{this.capitalizeFirstLetter(v)}</label>
                        </div>
                      )
                    })
                  }
                </div>

                {this.props.WebPage.Page.Creative.Own.map((v,i) => {
                  if(v.Size === fnd || v.LanguageCode === fnd && (v.Size !== "196x26" && v.Size !== "150x16")) {
                    return (
                      <div key={"own-" + i} className={"row"}>
                        <div className={"col_100 center-content"} style={{marginTop: "10px", display: "flex", justifyContent: "center", alignContent: "center"}} >
                          <a href={v.TargetUrl} rel={"nofollow"}><img src={v.ImageUrl} /></a>
                        </div>
                        <div className={"col_100"} style={{marginTop: "10px"}}>
                          <textarea defaultValue={v.Html} style={{resize: "none", minHeight: "65px", overflow: "hidden"}} />
                        </div>
                      </div>
                    );
                  }
                })}
              </React.Fragment>
              }




            </div>

            <div className="white-box mb">
              {showOther &&
              <div className="row"  style={{fontSize: "1.3rem", marginBottom: "20px", marginRight: "15px", display: "flex", justifyContent: "center"}}>
                <div className="col_33" style={{marginBottom: "20px"}}>
                  <Link to={wActs.getCultPath(this.props.WebPage, "/links?filter=ournetwork")} className="button" onClick={(e) => {
                    this.setState({filter: "ournetwork"});
                  }}
                  >{this.getTranslation("page.advertise.ournetwork")}</Link>
                </div>
                <div className="col_33" style={{marginBottom: "20px"}}>
                  <Link to={wActs.getCultPath(this.props.WebPage, "/links?filter=other")} className="button" onClick={(e) => {
                    this.setState({filter: "other"});
                  }}>{this.getTranslation("menu.other")}</Link>
                </div>
                <div className="clear"></div>
              </div>
              }
              {(this.state.filter == "linkexchange" && this.props.Links.ApiResult.Result) &&
              <div className="row centered-content">
                <p style={{ fontSize: "2.6rem", color: "#000", fontWeight: "400", textAlign: "center"}}><FormattedMessage id={"page.links.linkexchange"}>{(...content) => content}</FormattedMessage></p>
                {this.props.Links.ApiResult.Result.map((v,i)=> {
                  return (
                    <div className="flex-center-links">
                      <a href={v.TargetUrl} title={v.Title}><img src={v.ImageUrl} alt={v.AltText} style={{width: "468px", height: "60px"}}/></a>
                    </div>
                  );
                })}
                {this.props.Links.ApiResult.Context.TotalPages>1 &&
                <Pager skipScroll={true} ShowPages={3} Page={this.props.Links.ApiResult.Context.Page} TotalPages={this.props.Links.ApiResult.Context.TotalPages} Count={this.props.Links.ApiResult.Context.Count} />
                }
              </div>
              }
              {(this.state.filter == "ournetwork") &&
              <div className="row centered-content">
                <p style={{ fontSize: "2.6rem", color: "#000", fontWeight: "400", textAlign: "center"}}><FormattedMessage id={"page.advertise.ournetwork"}>{(...content) => content}</FormattedMessage></p>

                <div className="flex-center">
                  <div className="flex-center-links">
                    <SsrBanner apiAnonId={this.props.WebPage.Request.AnonymousId} ZoneId="featured-links-468x60" className="newbottom-lbanners">
                      <BuyAdBanner size={"468x60"} textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
                    </SsrBanner>
                    <SsrBanner IsHome={true} apiAnonId={this.props.WebPage.Request.AnonymousId} ZoneId="links-468x60" className="newbottom-lbanners">
                      <BuyAdBanner size={"468x60"} textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
                    </SsrBanner>
                  </div>
                </div>
              </div>
              }

              {this.state.filter == "other" &&
              <React.Fragment>
                <p style={{ fontSize: "2.6rem", color: "#000", fontWeight: "400", textAlign: "center"}}><FormattedMessage id={"menu.other"}>{(...content) => content}</FormattedMessage></p>
                <div key={"lnk-htmlsections"} className={"row center-content"} style={{ marginTop: "10px", marginBottom: "40px"}}>
                  <div className={"col_100 center-content banner-list"}>
                    <HtmlSection UseDiv={true} Id={"Friends"}/>
                  </div>
                </div>
              </React.Fragment>
              }



            </div>



          </div>
          <SideBanners/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Sites: state.Website.Page.Domains,
    WebPage: state.Website,
    HtmlSections: state.Website.Settings.HtmlSections,
    Links: state.Website.Links
  };
}

export default connect(mapStateToProps)(Links);
